import {
  Directive,
  Input,
} from '@angular/core';
import { LMStyleDirectiveBase } from './lm-style-directive.base';

@Directive({
  selector: '[lm-text-style]', // tslint:disable-line
})
export class LMTextStyleDirective extends LMStyleDirectiveBase {
  @Input() set textStyle(textStyle: LMTextStyle) {
    this.setStyle(textStyle);
  }
}
